import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/** Верхнеуровневый перехватчик ошибок рендера: вместо белого экрана
 *  показываем сообщение и кнопку перезагрузки. Ошибки асинхронных
 *  обработчиков (await/таймеры) он не ловит — для них есть try/catch.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('App render error:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <h1 style={{ fontSize: '1.3rem', margin: 0 }}>Произошла ошибка отображения</h1>
          <p style={{ margin: 0, color: '#666' }}>
            Перезагрузите страницу. Если ошибка повторяется — сообщите администратору.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 18px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}